// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"usps-2025_uk-open__yUjmP","grecaptcha-badge":"usps-2025_grecaptcha-badge__wZsiS","root":"usps-2025_root__GiVZu","usp":"usps-2025_usp__Vw0zP","icon":"usps-2025_icon__9v90o","onLight":"usps-2025_onLight__EP5D9"};
    if(module.hot) {
      // 1793877037622
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  